const UserDetails = ({userDetails}) => {
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>User Details</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row">
                    <span>Name</span>
                    <span>{userDetails.name}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Email</span>
                    <span>{userDetails.email}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Role</span>
                    <span>{userDetails.role?.charAt(0).toUpperCase() + userDetails.role?.slice(1)}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Registered On</span>
                    <span>
                        {new Date(userDetails.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        })}
                    </span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Email Verified</span>
                    <span>{userDetails.emailVerified ? <i title="Email verified" class="fa-solid fa-circle-check" style={{color: 'green'}}></i> : <i title="Email not verified" class="fa-solid fa-circle-exclamation" style={{color: 'red'}}></i>}</span>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;
